import { BackgroundColors, BorderRadius } from "@abel-technologies-as/components";
import styled, { css } from "styled-components";

const Container = styled.div`
	margin-top: 40px;
`;

const CodeWrapper = styled.div`
	padding: 11px 19px;
	border-radius: ${BorderRadius.XL}px;
	background-color: ${BackgroundColors.Primary};
	width: fit-content;
	box-shadow: 0px 1px 2px 0px #1018280d;
	border: 1px solid ${BackgroundColors.BluePrimary};
	margin-bottom: 16px;
`;

const fieldContainerStyle = css`
	padding: 10px 12px;
	border-top-right-radius: 0px;
	border-bottom-right-radius: 0px;
	border-right: 0px;
`;

export { Container, CodeWrapper, fieldContainerStyle };
